import { Button } from "./ui/button";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { Upload, Brain, FileText } from "lucide-react";

const steps = [
  {
    number: "01",
    icon: Upload,
    title: "Envie os Dados",
    description: "Use o link do leilão ou envie fotos do veículo que deseja analisar.",
  },
  {
    number: "02",
    icon: Brain,
    title: "IA Analisa",
    description: "Processamos milhares de dados em segundos com inteligência artificial.",
  },
  {
    number: "03",
    icon: FileText,
    title: "Receba o Relatório",
    description: "Veja custos, reparos estimados e sua margem de lucro potencial.",
  },
];

export function HowItWorks() {
  return (
    <section className="py-24 md:py-32 bg-muted/30">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8 max-w-7xl">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.5 }}
          className="text-center mb-16 space-y-4"
        >
          <h2 className="text-3xl sm:text-4xl lg:text-5xl font-heading font-bold tracking-tight">
            Como Funciona
          </h2>
          <p className="text-lg text-muted-foreground max-w-2xl mx-auto">
            Três passos simples para uma análise completa do seu veículo
          </p>
        </motion.div>

        <div className="grid md:grid-cols-3 gap-8 lg:gap-12 max-w-6xl mx-auto">
          {steps.map((step, index) => (
            <motion.div
              key={step.number}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.5, delay: index * 0.15 }}
              className="relative group"
            >
              <div className="bg-card/50 backdrop-blur-sm border border-border/50 rounded-2xl p-8 h-full hover:border-primary/30 hover:shadow-lg transition-all duration-300">
                {/* Número grande estilizado */}
                <span className="absolute -top-4 -left-2 text-8xl font-heading font-bold text-primary/10 group-hover:text-primary/20 transition-colors select-none">
                  {step.number}
                </span>
                
                <div className="relative z-10 space-y-4">
                  {/* Ícone */}
                  <div className="w-14 h-14 rounded-xl bg-primary/10 flex items-center justify-center group-hover:bg-primary/20 transition-colors">
                    <step.icon className="w-7 h-7 text-primary" />
                  </div>
                  
                  <h3 className="text-xl font-heading font-semibold">{step.title}</h3>
                  <p className="text-muted-foreground leading-relaxed">{step.description}</p>
                </div>
              </div>
            </motion.div>
          ))}
        </div>

        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.5, delay: 0.5 }}
          className="text-center mt-14"
        >
          <Button asChild size="lg" className="text-base px-8">
            <Link to="/cadastro" aria-label="Experimentar Gratuitamente">
              Experimentar Gratuitamente
            </Link>
          </Button>
        </motion.div>
      </div>
    </section>
  );
}
